import { API } from '../../utils/api'

// Mutation
export const MAKE_REQUEST = 'MAKE_REQUEST'
export const MAKE_POST_REQUEST = 'MAKE_POST_REQUEST'
export const MAKE_PUT_REQUEST = 'MAKE_PUT_REQUEST'

export default function createAPIPlugin () {
	return store => {
		store.subscribe (mutation => {
			switch (mutation.type) {
			case MAKE_REQUEST:
				API.get ({ ...mutation.payload, store })
				break
			case MAKE_POST_REQUEST:
				API.post ({ ...mutation.payload, store })
				break
			case MAKE_PUT_REQUEST:
				API.put ({ ...mutation.payload, store })
				break
			default:
				break
			}
		})
	}
}